import axios from "axios";
import Global from "../../fuse-configs/Global.js";
import querystring from "querystring";

export const autenticarUsuario = (email, password) => {
  const requestURL = Global.url + "/login";
  return axios.post(requestURL, querystring.stringify({ email, password }));
};
